module.exports = __webpack_public_path__ + "media/images/blogapalooza-2025-4906ffa1e9cf1467139dd32300aec82f.png";